import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { RolesComponent } from './roles/roles.component';
import { UsersComponent } from './users/users.component';

const routes: Routes = [
  {
    path: '',
    children: [
      {
        path: 'roles',
        component: RolesComponent,
        data: {
          urls: [
            { title: 'Roles', url: '/security/roles'}
          ]
        }
      },
      {
        path: 'users',
        component: UsersComponent,
        data: {
          urls: [
            {title: 'Usuarios', url: '/security/users'}
          ]
        }
      }
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class InnerSecurityRoutingModule { }
